/**
 * Geo / address lookup (Azure Maps Search, proxied through the API so the key
 * stays server-side). Powers address autocomplete in the project forms.
 */
import { z } from 'zod';
/** One ranked address suggestion. Fields may be empty when Azure can't resolve
 *  a component; the client merges what's present into the form's address. */
export const AddressSuggestionSchema = z.object({
    /** Human-readable single-line address for the dropdown. */
    label: z.string(),
    /** Company / building / landmark name when the hit came from the POI index
     *  (e.g. "VariSpace Southlake"); null for a plain street-address hit. */
    poi_name: z.string().nullish(),
    line1: z.string(),
    city: z.string(),
    /** US 2-letter state code when available. */
    state: z.string(),
    postal_code: z.string(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
});
export const AddressSearchQuerySchema = z.object({
    q: z.string().min(3).max(200),
});
export const AddressSearchResponseSchema = z.object({
    /** Empty when no provider key is configured (feature off) or no matches. */
    suggestions: z.array(AddressSuggestionSchema),
});
//# sourceMappingURL=geo.js.map